const config = {
    backURL: 'https://glorious-appliance-production.up.railway.app',
    backAPI: 'https://glorious-appliance-production.up.railway.app/api/admin'
    // backURL: 'http://127.0.0.1:8080',
    // backAPI: 'http://127.0.0.1:8080/api/admin',
}

export default config